import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr'
import Axios from 'axios';
export default {
    install (Vue) {
      const connection = new HubConnectionBuilder()
        //.withUrl('http://192.168.1.11:45455//question-hub')
        .withUrl(Axios.defaults.baseURL + '///logbook-hub')
        .configureLogging(LogLevel.Information)
        .build()
  
      const logbookHub = new Vue() // use new Vue instance as an event bus
  
      connection.on('Added', logbook => {
        logbookHub.$emit('logbook-added', logbook)
      })
      connection.on('Updated', logbook => {
        logbookHub.$emit('logbook-updated', logbook)
      })
      connection.on('Deleted', id =>{
        logbookHub.$emit('logbook-deleted', id)
      })
      connection.on('Data', logbooks => {
        logbookHub.$emit('reload-data', logbooks)
      })
      // Add the hub to the Vue prototype, so every component can listen to events or send new events using this.$questionHub
      Vue.prototype.$logbookHub = logbookHub
      
      // You need to call connection.start() to establish the connection
      // the client wont handle reconnecting for you! Docs recommend listening onclose
      // and handling it there. This is the simplest of the strategies
      let startedPromise = null
      function start () {
        startedPromise = connection.start()
          .catch(err => {
            console.error('Failed to connect with prevision hub', err)
            return new Promise((resolve, reject) => setTimeout(() => start().then(resolve).catch(reject), 5000))
          })
        return startedPromise
      }
      connection.onclose(() => start())
  
      //start()
    }
  }
  